const PageQuotation = () => import('./PageQuotation');

export default {
  name: 'quotation',
  path: ':id?',
  meta: {
    title: 'Detalhe da Cotação: {{ id }}',
  },
  component: PageQuotation,
};




// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/quotations/pages/quotation/routes.js